import React, { useState, useEffect } from "react";
import axios from "axios";
import MovieCard from "./MovieCard.js";

const NewReleases = () => {
  const [newReleases, setNewReleases] = useState([]);

  useEffect(() => {
    axios
      .get(
        "https://api.themoviedb.org/3/movie/now_playing?api_key=864351c4983b669ad95578b475142944&language=en-US&page=1"
      )
      .then((res) => {
        setNewReleases(res.data.results);
        console.log(res.data.results);
      })

      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="row row-cols-1  row-cols-sm-2 row-cols-md-3 row-cols-lg-4 NewRel ">
      {newReleases.map((newRel) => (
        <MovieCard movie={newRel}/>
      ))}
    </div>
  );
};

export default NewReleases;
